import ReactDOM from 'react-dom';

// 接口-校验域名和获取配置
import ChatMain from '@/pages/chatMain';
import { getConfig, getGuideQuestion, validateDomain } from '@/utils/api';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import VConsole from 'vconsole';
// 立即执行函数
window.forNativeVideoStatus = false;
window.unReadMesaggeCount = {
  count: 0,
};
window.domainArr = [
  'www.connectnowai.com',
  'connectnowai.com',
  'www.connectnow.cn',
  'connectnow.cn',
  'test.connectnowai.com',
  'dev.connectnowai.com',
  'eu.connectnowai.com',
  'us.connectnowai.com',
  'www.connectnow.world',
  'connectnow.world',
  // 'localhost',
];
(async function () {
  const livechatDiv = document.getElementById('ConnectNowChat');
  console.log('livechatDiv', livechatDiv);
  if (livechatDiv) {
    livechatDiv.remove();
  }
  try {
    loadChatCss();
    // 获取Chat入参信息
    let entryParam = window['goclouds']?.ac[0][0];
    if (!entryParam) {
      entryParam = window['connectnow']?.ac[0][0];
    }
    // entryParam = {
    //   // 公司id
    //   v: 'd6ff59a027861d7d4133e1d6b6872464',
    //   // 获取Amazon Connect实例信息
    //   i: '',
    //   // 客户名称
    //   un: '',
    //   // 客户邮箱
    //   ue: '',
    //   // 客户Id menberId
    //   m: '',
    //   // 客户手机号
    //   um: '',
    //   singleChat: true,
    //   // showToAgentName: false,
    //   // useNewMobileChat: true,
    //   // mobileIconPosition: {
    //   //   bottom: 'auto',
    //   //   right: '30px',
    //   //   top: '30px',
    //   //   left: 'auto',
    //   // enableConfigTool: true,
    //   isDebuggerMode: true,
    //   chatWindowTriggerIcon: 'https://pic.qqans.com/up/2022-10/202210271112567270.png',
    //   // },
    // };
    if (entryParam?.enableConfigTool) {
      entryParam = { v: entryParam.v, enableConfigTool: true, ...JSON.parse(localStorage.getItem('configTool')) };
    }
    if (entryParam?.isDebuggerMode) {
      new VConsole();
    }

    // console.log('entryPaxram>>>', entryPaxram);
    let companyId = entryParam.v;
    let instanceId = entryParam.i;
    let username = entryParam.un;
    let userEmail = entryParam.ue;
    let memberId = entryParam.m;
    let userMobile = entryParam.um;
    let country = entryParam.country;
    let containerW = entryParam.w;
    let containerH = entryParam.h;
    let channelType = entryParam.channelType;
    let fullScreen = entryParam.fullScreen; //控制是否全屏显示
    let singleChat = entryParam.singleChat; //是否多个会话
    let chatWindowTriggerIcon = entryParam.chatWindowTriggerIcon; //聊天窗口触发图标
    let showEndCustomerName = entryParam.showEndCustomerName; // 是否显示客户名称
    let showOnlineMediaForVIP = entryParam.showOnlineMediaForVIP; // 是否显示在线语音和视频
    let noHeader = entryParam.noHeader; //是否显示头部,建议和singlechat一同使用
    let ticketAttr = entryParam.ticketAttr || {}; //客户自定义入参
    let useNewMobileChat = entryParam.useNewMobileChat; //是否使用新版移动端聊天
    let mobileIconPosition = entryParam.mobileIconPosition; //移动端图标位置
    let showToAgentName = entryParam.showToAgentName; // 是否显示转人工按钮文字
    let ticketObj = {};
    let ticketAttrAiAgent = {}; // 给aiAgent使用
    let mobileEnterSendMessage = entryParam.mobileEnterSendMessage; //手机端控制回车发送
    let languageCode = entryParam.languageCode; // 接收客户传入的语言参数。
    let enableConfigTool = entryParam.enableConfigTool; // 是否启用配置工具
    // 循环ticketAttr
    if (Object.keys(ticketAttr).length !== 0) {
      for (let key in ticketAttr) {
        ticketObj['extended_' + key] = ticketAttr[key];
        ticketAttrAiAgent[key] = ticketAttr[key].value;
      }
    }

    // let noIcon = entryParam.noIcon; //控制是否显示客服图标
    if (!entryParam.v) {
      console.log('缺少公司信息，请检查配置或联系管理员');
      return;
    }
    if (!entryParam.channelType) {
      console.log('缺少渠道类型信息');
      channelType = '8';
    }

    // 获取网站信息
    let domain = document.domain;
    // let domain = 'localhost'; //生产地址
    entryParam.domain = domain;

    let language = languageCode || navigator.language || 'zh';
    // 如果客户传入的语言code不为空则使用
    // if (languageCode) {
    //   language = languageCode;
    // }
    console.log('entryParam', entryParam);

    // 查询是否存在在白名单中
    const validateResult = await validateDomain({ domain: domain, companyId: companyId });
    if (!validateResult.data) {
      console.error('域名未在白名单中，请联系系统管理员');
      return;
    }

    // 设备类型，mobile/pc
    const device = getDevice();
    let params = {
      companyId: companyId,
      instanceId: instanceId || '',
      language: language,
      domain: domain,
      // domain: 'test.connectnowai.com',
      channelType: channelType,
    };
    // console.log('getConfig - params', params);
    // 获取此实例的配置信息。
    const configResult = await getConfig(params);
    if (configResult.code !== 200) {
      return;
    }
    let data = configResult.data;
    // console.log('data>>>>>', data);
    data.companyId = companyId;
    let contactInfo = {};
    // 增加判断如果是aiagent的页面则需要保存用户的邮箱或手机号
    let obj = JSON.parse(localStorage.getItem('goclouds-chat-form'));
    if (!obj?.phoneNumber && !obj?.userEmail && (!userEmail || !userMobile) && window.domainArr.includes(domain)) {
      localStorage.setItem('goclouds-chat-form', JSON.stringify(null));
    } else {
      contactInfo = {
        username: username || obj?.username || '',
        userEmail: userEmail || obj?.userEmail || '',
        phoneNumber: userMobile || obj?.phoneNumber || '',
      };
      localStorage.setItem('goclouds-chat-form', JSON.stringify(contactInfo));
    }

    // 处理本地数据
    const localForm = JSON.parse(window.localStorage.getItem('goclouds-chat-form'));
    if (localForm !== null) {
      entryParam.un = username || localForm.username;
      entryParam.ue = userEmail || localForm.userEmail;
      entryParam.m = memberId || localForm.memberId;
      entryParam.um = userMobile || localForm.userMobile;
      entryParam.localForm = true;
    }
    let options = buildChatClientOptions(data, entryParam);

    try {
      if (options.documentKnowledgeBaseId) {
        let questionResult = await getGuideQuestion({
          companyId: companyId,
          knowledgeId: options.documentKnowledgeBaseId,
        });
        if (questionResult.code !== 200) {
          return;
        }
        options.guideQuestion = questionResult.data;
      }
      if (country) {
        options.extendedCountry = country;
      }
      options.channelType = channelType;
      options.containerW = containerW;
      options.containerH = containerH;
      options.isVideoContainer = channelType == 10 || channelType == 11 || channelType == 17 || channelType == 18;
      options.fullScreen = fullScreen ? fullScreen : false;
      options.singleChat = singleChat ? singleChat : false;
      options.chatWindowTriggerIcon = chatWindowTriggerIcon;
      options.useNewMobileChat = useNewMobileChat ? useNewMobileChat : false;
      options.mobileIconPosition =
        useNewMobileChat && mobileIconPosition
          ? mobileIconPosition
          : {
              bottom: '30px',
              right: '50px',
              top: 'auto',
              left: 'auto',
            };
      options.showToAgentName = showToAgentName;
      options.mobileEnterSendMessage = mobileEnterSendMessage ? mobileEnterSendMessage : true;
      options.showEndCustomerName = showEndCustomerName ? showEndCustomerName : false;
      options.showOnlineMediaForVIP = typeof showOnlineMediaForVIP === 'boolean' ? showOnlineMediaForVIP : true;
      options.noHeader = noHeader ? noHeader : false;
      options.ticketAttr = ticketObj;
      options.ticketAttrAiAgent = ticketAttrAiAgent;
      options.language = language;
      options.enableConfigTool = enableConfigTool ? enableConfigTool : false;
      let localFingerprintId = localStorage.getItem('fingerprintId');
      if (localFingerprintId) {
        options.fingerprintId = localFingerprintId;
      } else {
        const fpPromise = FingerprintJS.load();
        await fpPromise.then((fp) => {
          fp.get().then((result) => {
            options.fingerprintId = result.visitorId;
            localStorage.setItem('fingerprintId', result.visitorId);
          });
        });
      }
    } catch (e) {}

    console.log('options', options);
    const containerId = 'ConnectNowChat';

    createDomNode(containerId);

    // 加载客户端...
    ReactDOM.render(<ChatMain config={options} device={device} />, document.getElementById(containerId));
  } catch (e) {
    console.error('exception log', e);
  }
})();

/**
 * 构建Chat客户端配置数据
 *
 * @param configData 接口返回的Chat配置数据
 * @param username 客户名称
 * @returns Object Chat客户端所需数据
 */
let options = {};
function buildChatClientOptions(configData, entryParams) {
  if (configData === null) {
    return null;
  }

  // let name = username || '客户' + Math.floor(Math.random() * 10000);
  options = {
    channelId: configData.channelId,
    companyId: configData.companyId,
    username: entryParams.un, // 客户名称
    userEmail: entryParams.ue, // 客户邮箱
    memberId: entryParams.m, // 客户ID
    userMobile: entryParams.um, // 客户手机
    languageCode: entryParams.languageCode?.split('-')[0] || navigator.language?.split('-')[0],
    domain: entryParams.domain, // 域名
    isHomepage: domainArr.includes(entryParams.domain), // 是否是首页or选择使用新版移动端聊天
    region: '', // aws区域
    apiGateway: '', // apiGateway地址
    instanceId: '', // connect实例ID
    contactFlowId: '', // connect联系流ID
    chatLanguage: '', // 语言

    chatIconOpen: '', // 聊天组件按钮-展开
    chatIconClose: '', // 聊天组件按钮-关闭

    chatThemeColor: '', // 主题颜色编码
    chatCompanyLogo: '', // 公司logo
    chatTitle: '', // 标题文案
    chatFormIcon: '', // 表单图标
    chatSubmit: '', // 表单提交按钮文案

    chatServiceColor: '', // 聊天消息框底色编码-坐席
    chatMessageColor: '', // 聊天消息框底色编码-客户
    endOfConversation: '', // 结束聊天文案

    // 表单页字段
    preChatForm: {
      visible: true, // 是否可见
      inputFields: [], // 表单输入框列表
    },
  };

  let fieldType1Array = configData.paramList.filter((i) => i.fieldType === 1);
  // 系统字段
  fieldType1Array.forEach((item) => {
    let code = item.code;

    switch (code) {
      case 'chat_region':
        options.region = item.name;
        break;
      case 'chat_api_gateway':
        options.apiGateway = item.name;
        break;
      case 'chat_connect_instance_id':
        options.instanceId = item.name;
        break;
      case 'chat_connect_contact_flow_id':
        options.contactFlowId = item.name;
        break;
      case 'chat_language':
        options.chatLanguage = item.name;
        break;
      case 'chat_theme_color':
        options.chatThemeColor = item.name;
        break;
      case 'chat_icon_open':
        options.chatIconOpen = item.name;
        break;
      case 'chat_icon_close':
        options.chatIconClose = item.name;
        break;
      case 'chat_company_logo':
        options.chatCompanyLogo = item.name;
        break;
      case 'chat_title':
        options.chatTitle = item.name;
        break;
      case 'chat_form_icon':
        options.chatFormIcon = item.name;
        break;
      case 'chat_submit':
        options.chatSubmit = item.name;
        break;
      case 'chat_service_color':
        options.chatServiceColor = item.name;
        break;
      case 'chat_message_color':
        options.chatMessageColor = item.name;
        break;
      case 'end_of_conversation':
        options.endOfConversation = item.name;
        break;
      case 'open_video_button':
        options.openVideoButton = item.name;
        break;
      case 'video_tips':
        options.videoTips = item.name;
        break;
      case 'video_connecting':
        options.videoConnecting = item.name;
        break;
      case 'video_end':
        options.videoEnd = item.name;
        break;
      case 'mute':
        options.mute = item.name;
        break;
      case 'unmute':
        options.unmute = item.name;
        break;
      case 'start_video':
        options.startVideo = item.name;
        break;
      case 'stop_video':
        options.stopVideo = item.name;
        break;
      case 'bot_name': // 渠道方代理名称（客服名称）
        options.botName = item.name;
        break;
      case 'video_tips_accept':
        options.videoTipsAccept = item.name;
        break;
      case 'video_tips_cancel':
        options.videoTipsCancel = item.name;
        break;
      case 'menu_to_agent_icon': // 转人工图标
        options.menuToAgentIcon = item.name;
        break;
      case 'menu_to_agent_txt': // 转人工文案
        options.menuToAgentTxt = item.name || '';
        break;
      case 'chat_welcome_content': // 消息欢迎语
        options.chatWelcomeContent = item.name;
        break;
      case 'video_api_gateway': // 视频apigateway
        options.videoApiGateway = item.name;
        break;
      case 'open_video': // 是否开启视频功能
        options.openVideo = item.name;
        break;
      case 'open_audio': // 是否开启视频功能
        options.openAudio = item.name;
        break;
      case 'chat_connect_video_contact_flow_id': // 视频联系流
        options.chatConnectVideoContactFlowId = item.name;
        break;
      case 'open_knowledge_welcome': // 是否使用配置中的欢迎语，1使用，其他不使用
        options.openKnowledgeWelcome = item.name;
        break;
      case 'knowledge_welcome_q_id': // 欢迎qid
        options.knowledgeWelcomeQId = item.name;
        break;
      case 'chat_form_visible': //是否显示表单
        // 判断是否开启表单
        options.chatFormVisible = item.name === '1';
        // 如果设置了开启表单，则判断是否传了memberId,传了就不展示form
        if (options.chatFormVisible) {
          if (options.memberId) {
            options.chatFormVisible = false;
          } else if (entryParams.localForm) {
            options.chatFormVisible = false;
          }
        }
        break;
      case 'chat_automatic_wake_interval': //自动唤起时间
        options.chatAutomaticWakeInterval = item.name;
        break;
      case 'chat_open_channel_type': //开启聊天类型，0knowledge机器人和connect人工，1仅knowledge机器人，2仅connect人工
        options.chatOpenChannelType = item.name;
        break;
      case 'knowledge_unknown_reply': //机器人未知问题答复文案
        options.chatKnowledgeUnknownReply = item.name;
        break;
      case 'knowledge_unknown_transfer_agent': //是否开启机器人未知问题转人工
        options.chatKnowledgeUnknownTransferAgent = item.name;
        break;
      case 'chat_invite_proactively_flag': //是否开启自动唤起窗口功能
        options.chatInviteProactivelyFlag = item.name;
        break;
      case 'chat_satisfaction_evaluation_flag': //是否开启满意度评价功能
        options.chatSatisfactionEvaluationFlag = item.name;
        break;
      case 'satisfaction_evaluation_message': // 满意度评价消息中的文案
        options.satisfactionEvaluationMessage = item.name;
        break;
      case 'satisfaction_evaluation_tips': // 满意度评价操作区域中的文案
        options.satisfactionEvaluationTips = item.name;
        break;
      case 'close_chat_button': // 关闭窗口按钮文案
        options.closeChatButton = item.name;
        break;
      case 'wait_in_line_before': // 排队人数文案前半段
        options.waitInLineBefore = item.name;
        break;
      case 'wait_in_line_later': // 排队人数文案后半段
        options.waitInLineLater = item.name;
        break;
      case 'message_read': // 客户消息已读
        options.messageRead = item.name;
        break;
      case 'message_sending': // 客户消息发送中
        options.messageSending = item.name;
        break;
      case 'message_delivered': // 客户消息已送达
        options.messageDelivered = item.name;
        break;
      case 'end_chat_message': // 聊天结束的提示
        options.endChatMessage = item.name;
        break;
      case 'join_chat_message': // 加入聊天的提示
        options.joinChatMessage = item.name;
        break;
      case 'user_anonymous_name': // 客户匿名
        let name = entryParams.un || item.name;
        options.username = name;
        break;
      case 'video_overturn': // app视频翻转按钮
        options.videoOverturn = item.name;
        break;
      case 'chat_mobile_upload': // 手机端上传图片按钮文字
        options.chatMobileUpload = item.name;
        break;
      case 'pop_welcome_msg': // 邀请页的文案
        options.popWelcomeMsg = item.name;
        break;
      case 'homepage_welcome_msg':
        options.homepageWelcomeMsg = item.name;
        break;
      case 'homepage_chat_title':
        options.homepageChatTitle = item.name;
        break;
      case 'homepage_chat_subtitle':
        options.homepageChatSubtitle = item.name;
        break;
      case 'homepage_recent_session':
        options.homepageRecentSession = item.name;
        break;
      case 'homepage_other_contact':
        options.homepageOtherContact = item.name;
        break;
      case 'whatsapp_qrcode_contact_msg':
        options.whatsappQrcodeContactMsg = item.name;
        break;
      case 'whatsapp_open_msg':
        options.whatsappOpenMsg = item.name;
        break;
      case 'whatsapp_contact_msg':
        options.whatsappContactMsg = item.name;
        break;
      case 'bot_be_replying_msg':
        options.botBeReplyingMsg = item.name;
        break;
      case 'history_msg_back':
        options.historyMsgBack = item.name;
        break;
      case 'create_new_chat_msg':
        options.createNewChatMsg = item.name;
        break;
      case 'open_email_subscribe_flag':
        options.openEmailSubscribeFlag = item.name;
        break;
      case 'relation_email_address':
        if (item.name) {
          options.relationEmailAddress = item.name;
        }
        break;
      case 'open_whatsapp_subscribe_flag':
        options.openWhatsappSubscribeFlag = item.name;
        break;
      case 'relation_whatsapp_phonenumber':
        if (item.name) {
          options.relationWhatsappPhonenumber = item.name.replace('+', '');
        }
        break;
      case 'document_knowledge_base_id':
        options.documentKnowledgeBaseId = item.name;
        break;
      case 'open_self_chat':
        options.openSelfChat = item.name || '0';
        break;
      case 'hold_to_speak':
        options.holdToSpeak = item.name || '';
        break;
      case 'audio_send_move_cancel':
        options.audioSendMoveCancel = item.name || '';
        break;
      case 'no_recording_permission':
        options.noRecordingPermission = item.name;
        break;
      case 'slide_up_to_cancel':
        options.slideUpToCancel = item.name;
        break;
      case 'cancel_sent':
        options.cancelSent = item.name;
        break;
      case 'no_text_detected':
        options.noTextDetected = item.name;
        break;
      case 'max_file_size':
        options.maxFileSize = item.name;
        break;
      case 'retry_info':
        options.retryInfo = item.name;
        break;
      case 'form_check_error_tip':
        options.formCheckErrorTip = item.name;
        break;
      case 'button_confirm':
        options.buttonConfirm = item.name;
        break;
      case 'button_cancel':
        options.buttonCancel = item.name;
        break;
      case 'chat_robot_icon': // 机器人/坐席头像
        options.chatRobotIcon = item.name;
        break;
      case 'chat_user_icon': // 客户头像
        options.chatUserIcon = item.name;
        break;
      case 'reassign_join':
        options.reassignJoin = item.name;
        break;
      case 'show_toagent_flag':
        options.showToAgentFlag = item.name;
        break;
      case 'be_typing': //正在输入
        options.beTyping = item.name;
        break;
      case 'recall_msg': //撤回消息
        options.recallMsg = item.name;
        break;
      case 'upload_file_tips': //上传文件提示
        options.uploadFileTips = item.name;
        break;
      case 'upload_file_click': //点击上传
        options.uploadFileClick = item.name;
        break;
      case 'card_choice':
        options.cardChoice = item.name;
        break;
      case 'is_recall_msg':
        options.isRecallMsg = item.name;
        break;
      case 'hot_question':
        options.hotQuestion = item.name;
        break;
      case 'enable_app_voice_input':
        options.enableAppVoiceInput = item.name;
        break;
      case 'no_available_agent':
        options.noAvailableAgent = item.name;
        break;
      case 'push_system_message_flag':
        options.pushSystemMessageFlag = item.name;
        break;
      case 'history_chat_num':
        options.historyChatNum = item.name;
        break;
      case 'show_history_chat_flag':
        options.showHistoryChatFlag = item.name;
        break;
      case 'is_show_form_field_phone': // 是否现实表单中的手机号字段。0不显示，反之都显示。
        options.isShowFormFieldPhone = item.name;
        break;
      case 'agent_not_worktime_reply':
        options.notWorkTime = item.name;
        break;
      case 'need_info_collection':
        options.needInfoCollection = item.name;
        break;
      case 'file_size_error_text': // 文件大小错误提示文案
        options.fileSizeErrorText = item.name;
        break;
      case 'file_size_error_button': // 文件大小错误提示按钮文案
        options.fileSizeErrorButton = item.name;
        break;
      case 'chat_user_font_color':
        options.userFontColor = item.name;
        break;
    }
  });
  if (options.botBeReplyingMsg) {
    options.botBeReplyingMsg = options.botBeReplyingMsg.replace('{botName}', options.botName);
  }
  // let fieldType3Array = configData.paramList.filter((i) => i.fieldType === 3);
  // 定义需要控制的字段配置映射
  const fieldVisibilityConfig = {
    chat_phone_number: options.isShowFormFieldPhone,
    // 可以添加其他字段配置，例如：
    // 'chat_user_name': options.isShowFormFieldUserName,
    // 'chat_email': options.isShowFormFieldEmail
  };

  let fieldType3Array = configData.paramList.filter(
    (item) => item.fieldType === 3 && !(fieldVisibilityConfig[item.code] === '0')
  );

  // 表单字段
  if (fieldType3Array.length === 0) {
    // 不显示表单页面
    options.preChatForm.visible = options.chatFormVisible === undefined ? false : options.chatFormVisible;
    options.preChatForm.inputFields = [];
  } else {
    // 显示表单页面
    options.preChatForm.visible = options.chatFormVisible === undefined ? false : options.chatFormVisible;

    options.preChatForm.inputFields[0] = {};
    options.preChatForm.inputFields[1] = {};

    fieldType3Array.forEach((item) => {
      let field = {
        code: item.code,
        name: item.name,
        type: 'text',
        validation: 'required',
      };
      if (item.code === 'chat_user_name') {
        options.preChatForm.inputFields[0] = field;
      } else if (item.code === 'chat_email') {
        field.validation =
          /^[a-zA0-9_.-]+@[a-z0-9-]+(.[a-z]+)*.(com|cn|net|hk|tw|de|fr|jp|lk|in|nz|ru|sg|il|fm|zm|ar|mk|gn|mx|fr|zw|ci|na|np|mn|to|om|za|sa|se|gr|all|au|at|qa|my|kr|pk|ae|vn|es|it|id|uk|pl|xyz|ltd|group|wang|club|work|gold|cool|life|art|love|world|asia|cc|biz|games|sale|media|fit|studio|fyi|cab|market|news|vin|tax|shopping|mba|cash|cafe|technology|co|fans|ren|cloud|shop|law|link|show|info|mobi|tv|top|vip|beer|fashion|luxe|online|chat|pub|run|city|live|pro|red|pet|kim|blue|ski|pink|space|host|fun|site|store|yoga|website|band|voto|archi|vote|promo|poker|organic|lotto|green|black|bio|social|zone|email|today|team|guru|fund|center|plus|video|wiki|design|company|icu|press|me|cf|ai|ink|la|ru|sarl|rs|rip|gd|pl)$/i;
        options.preChatForm.inputFields[1] = field;
      } else if (item.code === 'chat_phone_number') {
        options.preChatForm.inputFields[2] = {};
        field.validation = /^(?:\+\d{4,17}|\d{5,18})$/;
        options.preChatForm.inputFields[2] = field;
      } else {
        options.preChatForm.inputFields.push(field);
      }
    });
  }

  return options;
}

/**
 * 创建DOM
 * @param containerId id
 */
function createDomNode(containerId) {
  /*let newDiv = document.createElement('div');
  newDiv.id = containerId;
  newDiv.style.cssText = 'margin: 0; font-family: sans-serif !important;';
  let body = document.getElementsByTagName('body')[0];
  body.appendChild(newDiv);*/

  // 获取页面元素中第一个id为ConnectNowChat的div元素。
  let connectNowChatDiv = document.getElementById(containerId);

  // 判断是否这个元素是存在，如果不存在则创建新的div元素id为ConnectNowChat
  if (!connectNowChatDiv) {
    connectNowChatDiv = document.createElement('div');
    connectNowChatDiv.id = containerId;
  }

  connectNowChatDiv.style.cssText = 'margin: 0;';
  // 将这个div元素添加到body节点中。这样做是为了保证body中只有一个id为ConnectNowChat的div
  document.body.appendChild(connectNowChatDiv);
}

/**
 * 获取设备类型
 *
 * @returns string 移动端返回mobile，网页端返回pc
 */
function getDevice() {
  const userAgent = window.navigator.userAgent; // 获取User Agent信息
  let isMobileDevice = false;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    isMobileDevice = true; // 如果包含上述关键字之一，则认为是移动端
  } else if (/(Windows Phone)/i.test(userAgent) || /(Macintosh)/i.test(userAgent)) {
    isMobileDevice = false; // 否则认为是PC端
  }

  return isMobileDevice ? 'mobile' : 'pc';
}
function loadChatCss() {
  // 创建一个新的 link 标签
  let link = document.createElement('link');

  // 设置 rel 属性为 stylesheet
  link.rel = 'stylesheet';

  // 设置 href 属性为 umi.css 文件的URL
  /*let env = process.env.UMI_ENV;
  if (env === 'development') {
    // localhost使用
    // link.href = '../src/lib/umi.css';

    // 测试环境-s3桶名：287316796928上的goclouds-connectNow-chat-test
    link.href = 'https://d1362bz2rn3chi.cloudfront.net/umi.css';
  } else if (env === 'production') {
    // 生产环境-文件在香港account上的s3中
    // link.href = 'https://chat.connectnow.cn/umi.css';
    link.href = "https://"+process.env.API_HOST+"/umi.css";
  } else {
    link.href = "https://"+process.env.API_HOST+"/sg-chat/umi.css";
  }*/
  link.href = process.env.CSS_RESOURCES;

  // 将 link 标签添加到文档的 head 部分
  document.head.appendChild(link);
}
